import { businessKey } from 'queryKeys';

export const GALLERY_TAGS = 'galleryTags';

const gtQuery = businessKey.query(GALLERY_TAGS);
const ADD_TAGS = 'ADD_TAGS';
export const grid = gtQuery.grid();
export const model = gtQuery.exact();
export const details = gtQuery.details();
export const mutations = gtQuery.mutations();

export const create = mutations.create();
export const update = mutations.update();
export const remove = mutations.delete();
export const addTags = mutations.mutate(ADD_TAGS);
